import React from 'react';
import { Link } from 'gatsby';
import { colors } from 'themes/components';
import styled, { css } from 'styled-components';

const GradientStyles = css`
  padding: 8px 12px;
  border-radius: 8px;
  background: ${(
    props
  ) => `linear-gradient(to bottom right, ${colors.grey90}, ${colors.grey90}) padding-box,
    linear-gradient(to top left, ${props.borderColor1}, ${props.borderColor2}) border-box`};
  border: 1px solid transparent;
  color: ${colors.grey20};
  font-size: 13px;
  font-weight: 500;
  transition: background 0.3s ease;
  text-decoration: none;
  position: relative;
  z-index: 0;
  &:after {
    content: '';
    position: absolute;
    left: -1px;
    right: -1px;
    top: -1px;
    bottom: -1px;
    border-radius: 8px;
    z-index: 1;
    background: ${(props) =>
      `linear-gradient(135deg, ${props.hoverBg1}, ${props.hoverBg2})`};
    opacity: 0;
    will-change: opacity;
    transition: opacity 0.3s ease;
  }
  &:hover {
    color: ${colors.grey90};
    &:after {
      opacity: 1;
    }
  }
  & > span {
    position: relative;
    z-index: 2;
  }
`;

const InternalLink = styled(Link)`
  ${GradientStyles}
`;

const ExternalLink = styled.a`
  ${GradientStyles}
`;

const GradientButton = (props) =>
  props.external ? (
    <ExternalLink {...props} href={props.url}>
      <span>{props.children}</span>
    </ExternalLink>
  ) : (
    <InternalLink {...props} to={props.url}>
      <span>{props.children}</span>
    </InternalLink>
  );

export default GradientButton;
